import script from "./PermissionGroupsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionGroupsPage.vue?vue&type=script&setup=true&lang=js"

import "./PermissionGroupsPage.vue?vue&type=style&index=0&id=df774cfc&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./PermissionGroupsPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df774cfc"]])

export default __exports__